/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import * as React from "react";
import { Tooltip, IconButton, Menu, MenuItem } from "@mui/material";
import { menuSlotProps, moreIconButtonSxProps } from "../../../helpers";
import { IThresholdCrossingSettingAction } from "../../../../store/api/admin/types";
import { useStoreDispatch } from "../../../../store/hooks";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { setBasicDialogOpenFor, setOpenCustomDailog, setOpenToast } from "../../../../store/helpers/helperReducers";
import { useThresholdCrossingSettingActionData } from "./hooks";
import { DIALOGOPENFOR } from "../../../../globals/globals";
import { useState } from "react";
import { setThresholdCrossingSettingActionModelOpenMode, setSelectedThresholdCrossingSettingAction } from "../../../../store/api/admin/reducers";


interface IProfileActionMenuProps {
  tableRow: any;
  disableDelete?: boolean;
}

const ProfileActionMenu: React.FC<IProfileActionMenuProps> = ({ tableRow, disableDelete }) => {
  const dispatch = useStoreDispatch();
  const { deleteThresholdCrossingSettingActionHandler, anchorElThresholdCrossingSettingAction, setAnchorElThresholdCrossingSettingAction } = useThresholdCrossingSettingActionData(tableRow?.row);
  const openMenuThresholdCrossingSettingAction = Boolean(anchorElThresholdCrossingSettingAction);

  const handleOnMoreIconThresholdCrossingSettingActionClick = (event: React.MouseEvent<HTMLButtonElement>, selectedRow: any) => {
    setAnchorElThresholdCrossingSettingAction(event.currentTarget);
    dispatch(setSelectedThresholdCrossingSettingAction(selectedRow.row))
  };

  const addThresholdCrossingSettingActionHandler = () => {
    dispatch(setThresholdCrossingSettingActionModelOpenMode("Add"));
    dispatch(setBasicDialogOpenFor(DIALOGOPENFOR.THRESHOLDCROSSINGSETTINGACTION));
  };

  const editThresholdCrossingSettingActionHandler = () => {
    dispatch(setThresholdCrossingSettingActionModelOpenMode("Edit"));
    dispatch(setBasicDialogOpenFor(DIALOGOPENFOR.THRESHOLDCROSSINGSETTINGACTION));
  };

  const handlePopup = (type: string) => {
    setAnchorElThresholdCrossingSettingAction(null);
    if (type === "Edit") {
      return editThresholdCrossingSettingActionHandler();
    } else if (type === "Delete") {
      if (disableDelete) {
        dispatch(
          setOpenToast({
            openToast: true,
            toastType: "error",
            message: "You can not delete this action. At least one action is required.",
          })
        );
      }
      else {
        return deleteThresholdCrossingSettingActionHandler();
      }
    } else {
      return addThresholdCrossingSettingActionHandler();
    }
  };

  const isEnableMoreIcon = !!tableRow?.status && (tableRow?.status.toLowerCase() === "inprogress" || tableRow?.status.toLowerCase() === "failed");
  return (
    <>
      <Tooltip title="" arrow>
        <IconButton
          sx={moreIconButtonSxProps}
          aria-label="more"
          id="threshold-crossing-setting-action"
          aria-controls={openMenuThresholdCrossingSettingAction ? "threshold-crossing-setting-action-menu" : undefined}
          aria-expanded={openMenuThresholdCrossingSettingAction ? "true" : undefined}
          aria-haspopup="true"
          onClick={(event) => handleOnMoreIconThresholdCrossingSettingActionClick(event, tableRow)}
          disabled={isEnableMoreIcon}>
          <MoreVertIcon sx={{ fontSize: 18 }} />
        </IconButton>
      </Tooltip>
      <Menu
        id="threshold-crossing-setting-action-menu"
        anchorEl={anchorElThresholdCrossingSettingAction}
        open={openMenuThresholdCrossingSettingAction}
        onClose={() => setAnchorElThresholdCrossingSettingAction(null)}
        MenuListProps={{
          "aria-labelledby": "threshold-crossing-setting-action",
          className: "p-0",
          sx: { py: 0 , width: "110px"}
        }}
        PaperProps={{
          className: "rounded-md border bg-popover p-1 text-popover-foreground shadow-md",
          elevation: 0
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
       >
        <MenuItem onClick={() => handlePopup("Edit")}  style={{paddingLeft:8, minHeight: "26px"}} className="relative flex cursor-default select-none items-center gap-4 rounded-sm px-2 py-0.5 text-[11px] outline-none transition-colors hover:!bg-muted hover:!text-foreground hover:rounded">
          <EditIcon sx={{ fontSize: 15 }} className="text-foreground" />
           <span style={{ fontSize: 15 }} > Edit </span>
        </MenuItem>
        <MenuItem
          onClick={() => handlePopup("Delete")}
          style={{paddingLeft:8, height: "26px"}}
          className={`group relative flex cursor-default select-none items-center gap-4 rounded-sm px-2 py-0.5 text-[11px] outline-none transition-colors ${disableDelete ? "text-destructive opacity-50" : "text-destructive hover:!bg-muted hover:!text-foreground hover:rounded"}`}
        >
          <DeleteIcon sx={{ fontSize: 15 }} className={disableDelete ? "text-destructive" : "text-destructive group-hover:!text-foreground"} />
          <span style={{ fontSize: 15 }} className={disableDelete ? "text-destructive" : "text-destructive group-hover:!text-foreground"}>Delete</span>
        </MenuItem>
      </Menu>
    </>
  );
};

export default ProfileActionMenu;
